module.exports = __webpack_public_path__ + "static/media/Presage.e54e4904.jpg";